import React from "react";
import QuizContent from "../shared/QuizContent";
import QuizTitle from "../shared/QuizTitle";
import QuizOptions from "../shared/QuizOptions";
import QuizOption from "../shared/QuizOption";
import { getQuizOptions } from "../../utils/quizOptions";

const Step6 = ({ onAnswer }) => {
  const quizOptions = getQuizOptions("feel");

  const handleOptionClick = (value) => {
    onAnswer("feel", value);
  };

  return (
    <div className="quizContentWrapper">
      <QuizContent>
        <QuizTitle>
          What do you feel is missing in people surrounding you?
        </QuizTitle>
        <QuizOptions>
          {quizOptions.map((option) => (
            <QuizOption
              key={option.value}
              value={option.value}
              name="feel"
              onClick={handleOptionClick}
            >
              <div>
                <p>
                  <strong>{option.text}</strong>
                </p>
              </div>
            </QuizOption>
          ))}
        </QuizOptions>
      </QuizContent>
    </div>
  );
};

export default Step6;
